<template>
  <div class="btn-group w-100">
    <button
      class="btn btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown"
      data-bs-auto-close="outside" aria-expanded="false"
    >
      {{ $t("selecioneUmUsuario", users.length, { count: users.length }) }}
    </button>
    <ul class="dropdown-menu">
      <li class="dropdown-item">
        <a class="dropdown-item">
          <div class="form-check">
            <input
              id="checkAllUser" class="form-check-input" type="checkbox"
              :checked="users.length == userArray.length" @input="onCheckedAllUser"
            >
            <label class="form-check-label w-100" for="checkAllUser">{{ $t("todos") }}</label>
          </div>
        </a>
      </li>
      <li v-for="(user, index) in userArray" :key="index" class="dropdown-item">
        <a class="dropdown-item">
          <div class="form-check">
            <input
              :id="'checku' + index" v-model="users" class="form-check-input" :value="user.id"
              type="checkbox"
            >
            <label class="form-check-label w-100" :for="'checku'+index">{{ user.nome }}</label>
          </div>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { getUsers } from '@/modules/shared/listService';

export default {
  props: {
    modelValue: { type: Array, required: true },
  },
  emits: ['update:modelValue'],
  data: (props) => ({
    users: props.modelValue,
    userArray: [],
  }),

  watch: {
    users() {
      this.$emit('update:modelValue', this.users);
    },
  },
  async mounted() {
    await this.getUsersFilter();
    this.onCheckedAllUser();
  },

  methods: {
    async getUsersFilter() {
      this.userArray = await getUsers();
    },
    onCheckedAllUser() {
      this.users = this.users.length === this.userArray.length ? [] : this.userArray.map((user) => user.id);
    },
  },
};
</script>
